import script from "./PersonalActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalActivity.vue?vue&type=script&setup=true&lang=js"

import "./PersonalActivity.vue?vue&type=style&index=0&id=59d58ecd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d58ecd"]])

export default __exports__